(function() {
    setHtmlFontSize();
    window.onresize = () => {
        setHtmlFontSize();
    };

    function setHtmlFontSize() {
        let deviceWidth = document.documentElement.clientWidth,
            deviceHeight = document.documentElement.clientHeight;

        if (Math.abs(window.orientation) === 90) deviceWidth = deviceHeight;  //横屏状态

        document.getElementsByTagName("html")[0].style.fontSize = deviceWidth / 37.5 + "px";
    }
})();